import { IGetters } from './getters.types'
import { IGrantData } from '@/entities'
import { AppConstants as _app } from '@/shared/app.constants';
import {Utilities as _utils} from '@/shared/utilities';

export const getters: IGetters = {
    readGrant(state: IGrantData) {
        return state.selectedGrant;
    },
    readGrantData(state: IGrantData) {
        return state.grantData;
    }
}